/* WEELZ - "Picked for you" shelf renderer.
   Reads the on-device interest model, asks the Section Rendering API for the
   best-matching collections, re-ranks the cards and injects the winners.

   Perf contract: deferred; all work behind requestIdleCallback; the section
   is display:none until filled so a slow fetch can never shift layout; at
   most two requests, both after first paint; one DOMParser pass
   off-document; fails silently. */
(function () {
  var idle = typeof window.requestIdleCallback === 'function'
    ? function (f) { window.requestIdleCallback(f, { timeout: 2500 }); }
    : function (f) { window.setTimeout(f, 400); };

  function cartHandles() {
    var b = document.querySelector('.cart-bubble__text-count');
    if (!b || !parseInt(b.textContent || '0', 10)) return Promise.resolve([]);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { return c && c.items ? c.items.map(function (i) { return i.handle; }) : []; })
      .catch(function () { return []; });
  }

  function fetchCards(handle) {
    var u = '/collections/' + encodeURIComponent(handle) + '?section_id=weelz-for-you-grid&sort_by=best-selling';
    return fetch(u, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return [];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('.weelz-fy__card'));
      })
      .catch(function () { return []; });
  }

  function build(el) {
    var A = window.WeelzAffinity;
    var limit = parseInt(el.getAttribute('data-limit') || '8', 10);
    var fallback = el.getAttribute('data-fallback') || '';
    var current = el.getAttribute('data-exclude') || '';

    var targets = A ? A.top('col', 3) : [];
    if (fallback && targets.indexOf(fallback) === -1) targets.push(fallback);
    if (!targets.length) return;

    var seen = A ? A.seen() : [];
    // Product types this shopper actually looks at, best first.
    var types = A ? A.top('type', 5) : [];

    cartHandles().then(function (inCart) {
      // Never recommend the product being viewed, or anything already in the cart.
      var block = {};
      inCart.concat(current ? [current] : []).forEach(function (h) { if (h) block[h] = 1; });

      // Recently viewed items are demoted, not blocked: with a short history
      // a hard filter would empty the shelf.
      var demote = {};
      seen.slice(0, 8).forEach(function (h) { demote[h] = 1; });

      var chain = Promise.resolve([]);
      targets.slice(0, 3).forEach(function (handle) {
        chain = chain.then(function (acc) {
          if (acc.length >= limit * 2) return acc;
          return fetchCards(handle).then(function (cards) { return acc.concat(cards); });
        });
      });

      chain.then(function (cards) {
        var pool = [];
        var used = {};

        cards.forEach(function (c, order) {
          var h = c.getAttribute('data-handle');
          if (!h || used[h] || block[h]) return;
          if (c.getAttribute('data-available') === 'false') return;
          used[h] = 1;

          // Score: type affinity dominates, then original best-selling order.
          // A broad collection such as "summer edit" mixes departments, so
          // without this a shopper browsing men's polos could be shown kids
          // shorts purely because they share a collection.
          var ti = types.indexOf(c.getAttribute('data-type') || '');
          var score = ti === -1 ? 0 : (types.length - ti) * 10;
          if (demote[h]) score -= 100;

          pool.push({ el: c, score: score, order: order });
        });

        pool.sort(function (a, b) {
          return b.score - a.score || a.order - b.order;
        });

        var picked = pool.slice(0, limit);
        if (picked.length < 4) return;

        var grid = el.querySelector('.weelz-fy__grid');
        var frag = document.createDocumentFragment();
        picked.forEach(function (p, i) {
          p.el.style.setProperty('--i', String(i));
          p.el.setAttribute('role', 'listitem');
          frag.appendChild(p.el);
        });
        grid.appendChild(frag);

        var all = el.querySelector('.weelz-fy__all');
        if (all) {
          all.setAttribute('href', '/collections/' + targets[0]);
          all.hidden = false;
        }
        el.hidden = false;
      });
    });
  }

  function init() {
    var els = document.querySelectorAll('weelz-for-you[hidden]');
    for (var i = 0; i < els.length; i++) {
      (function (el) { idle(function () { try { build(el); } catch (e) {} }); })(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
